import { z } from "zod";

import { fillTemplate } from "../values/fill-template";
import copyJson from "./dashboard-copy.json";

const countNoteSchema = z.object({ one: z.string(), many: z.string() });
const orderDatesSchema = z.object({ submittedAt: z.string(), orderedAt: z.string(), arrivedDate: z.string() });
export const dashboardOrderDateFieldSchema = orderDatesSchema.keyof();

const copySchema = z.object({
  unknown: z.string(),
  unassigned: z.string(),
  invalidPeriod: z.string(),
  customPeriod: z.string(),
  orderDates: orderDatesSchema,
  orderPeriodDefinition: z.string(),
  periodErrors: z.object({ missingStart: z.string(), missingEnd: z.string(), reversed: z.string(), future: z.string() }),
  catalogErrors: z.object({ areasOrder: z.string(), periodsOrder: z.string(), orderDateFieldMissing: z.string() }),
  notes: z.object({ chartNumberRange: countNoteSchema, missingCountry: countNoteSchema, missingPrice: countNoteSchema, overpaid: countNoteSchema, missingOrderDate: countNoteSchema }),
});

export type CountNote = z.infer<typeof countNoteSchema>;

export const DASHBOARD_COPY = copySchema.parse(copyJson);


export function countNote(note: CountNote, count: number, values: Record<string, string> = {}): string {
  return fillTemplate(count === 1 ? note.one : note.many, { ...values, count });
}
